import { RolesScreen } from "@/screens/control-panel/roles";

/** Thin wrapper — toda lógica fica em screens/control-panel/roles */
export function RolesPage() {
  return <RolesScreen />;
}
